// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3Ab3J","error":"Textarea_error__1M6Aa","readonly":"Textarea_readonly__3T-7G","disabled":"Textarea_disabled__wUg4n"};